<template>
  <div style="margin-top: -10px;">
    <el-tabs v-model="activeName" class="tabs">
      <el-tab-pane label="待处理" name="todo">
        <CureOutlayTable :active="activeName"></CureOutlayTable>
      </el-tab-pane>
      <el-tab-pane label="被退回" name="rollback">
        <CureOutlayTable :active="activeName"></CureOutlayTable>
      </el-tab-pane>
      <el-tab-pane label="超期未填写" name="timeout">
        <CureOutlayTable :active="activeName"></CureOutlayTable>
      </el-tab-pane>
      <el-tab-pane label="已处理" name="done">
        <CureOutlayTable :active="activeName"></CureOutlayTable>
      </el-tab-pane>
      <el-tab-pane v-if="isBatchImport==1" label="批量操作" name="BatchOperation">
        <CureOutlayTable :active="activeName"></CureOutlayTable>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import CureOutlayTable from "./CureOutlayTable";
import {getAccountSystemInfo} from "../../../util/api";

export default {
  components: {
    CureOutlayTable
  },
  data() {
    return {
      activeName: 'todo',
      isBatchImport:null
    };
  },
  watch: {
    '$route.query.tap': {
      handler () {
        this.activeName = this.$route.query.tap
      }
    },
  },
  created() {
    this.getHospitalInfo();

    if(this.$route.query.tap){
      this.activeName = this.$route.query.tap
    }
  },
  methods:{
    getHospitalInfo(){
      getAccountSystemInfo().then((res) => {
        if(res.msgCode==200){
            this.isBatchImport=res.responseData.isBatchImport;
        }
      })
    }
  }
};
</script>

<style lang="scss" scoped>
@import "src/common/common";
</style>



// WEBPACK FOOTER //
// src/pages/outlay/cure/CureOutlayPage.vue